import { render, staticRenderFns } from "./myOxviewdetails.vue?vue&type=template&id=d81a1c4a&"
import script from "./myOxviewdetails.vue?vue&type=script&lang=js&"
export * from "./myOxviewdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports